import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

interface ToolCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  /** Shown as a badge next to the title, e.g. for a tool that is not wired yet. */
  status?: string;
  children?: ReactNode;
}

/** One per-tenant tool on the Solution Engineer page. */
export function ToolCard({
  icon: Icon,
  title,
  description,
  status,
  children,
}: ToolCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Icon className="text-muted-foreground h-5 w-5" />
          {title}
          {status && <Badge variant="secondary">{status}</Badge>}
        </CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      {children && <CardContent>{children}</CardContent>}
    </Card>
  );
}
